export default __webpack_public_path__ + "static/media/Nodata.aa2392fe.gif";